"use client";

import config from "@/app.config";
import SocialMedia from "./social-media";
import Link from "next/link";
import CallRoundedIcon from "@mui/icons-material/CallRounded";

export default function Announcement() {
  return (
    <div className="bg-zinc-100">
      <div className="max-w-8xl mx-auto px-4">
        <div className="h-[40px] flex items-center justify-between gap-4">
          <Link
            href={`tel:${config.contact.primaryPhone}`}
            className="hover:underline text-sm inline-flex items-center gap-x-1"
          >
            <CallRoundedIcon fontSize="small" />
            <span>{config.contact.primaryPhone}</span>
          </Link>
          <SocialMedia />
        </div>
      </div>
    </div>
  );
}
